import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoice-bulk-actions"
//
// Drives the bulk-action bar on admin invoice index pages:
//   - shows the "X invoices selected" bar + Send to Mercury/Mark Complete buttons
//     when any row checkbox is checked
//   - master checkbox toggles all visible row checkboxes
//   - syncs hidden invoice_ids[] inputs on both bulk forms with the current selection
export default class extends Controller {
  static targets = ["actionBar", "count", "masterCheckbox", "itemCheckbox", "mercuryForm", "completeForm"]

  connect() {
    this.updateState()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.itemCheckboxTargets.forEach((cb) => {
      cb.checked = checked
    })
    this.updateState()
  }

  updateState() {
    const selected = this.selectedIds()
    if (this.hasCountTarget) this.countTarget.textContent = selected.length

    if (this.hasActionBarTarget) {
      if (selected.length > 0) {
        this.actionBarTarget.classList.remove("hidden")
        this.actionBarTarget.classList.add("flex")
      } else {
        this.actionBarTarget.classList.add("hidden")
        this.actionBarTarget.classList.remove("flex")
      }
    }

    if (this.hasMasterCheckboxTarget) {
      const all = this.itemCheckboxTargets
      const checked = all.filter((cb) => cb.checked)
      if (all.length === 0) {
        this.masterCheckboxTarget.checked = false
        this.masterCheckboxTarget.indeterminate = false
      } else if (checked.length === all.length) {
        this.masterCheckboxTarget.checked = true
        this.masterCheckboxTarget.indeterminate = false
      } else if (checked.length === 0) {
        this.masterCheckboxTarget.checked = false
        this.masterCheckboxTarget.indeterminate = false
      } else {
        this.masterCheckboxTarget.checked = false
        this.masterCheckboxTarget.indeterminate = true
      }
    }

    if (this.hasMercuryFormTarget) {
      this.syncHiddenIds(this.mercuryFormTarget, selected)
    }

    if (this.hasCompleteFormTarget) {
      this.syncHiddenIds(this.completeFormTarget, selected)
    }
  }

  selectedIds() {
    return this.itemCheckboxTargets.filter((cb) => cb.checked).map((cb) => cb.value)
  }

  syncHiddenIds(form, ids) {
    form.querySelectorAll("input[data-bulk-id]").forEach((el) => el.remove())
    ids.forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "invoice_ids[]"
      input.value = id
      input.dataset.bulkId = "true"
      form.appendChild(input)
    })
  }
}
